// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__kQzIq","text":"Breadcrumb_text__0RDJ8","arrow":"Breadcrumb_arrow__y3zyn","rtl":"Breadcrumb_rtl__zBXJU"};